import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';

export default function single_toy() {
  if (!$('body').hasClass('single-toy')) return;

  var toy_gallery = lightGallery($('.toy-gallery')[0], {
    download: false,
    allowMediaOverlap: true,
    toggleThumb: true,
    plugins: [lgThumbnail],
    prevHtml: '<i class="far fa-angle-left"></i>',
    nextHtml: '<i class="far fa-angle-right"></i>',
    selector: '.toy-gallery__images a',
  });

  $('.toy-gallery__main a').click(function(e){
    e.preventDefault();

    toy_gallery.openGallery(0);
  });
}
